import { createSlice } from "@reduxjs/toolkit";

import { ALL } from "../../consts/shiftManagerDetails";

import {
  resetShiftManagerManagement,
  setShiftManagerView,
  fetchDepotShiftManagers,
  fetchDepotSections,
  setIsShiftManagerEditValid,
  cancelShiftManagerEdit,
  editShiftManager,
  updateShiftManagerEdit,
  saveShiftManager,
} from "./thunkActions";

const initialState = {
  loading: false,
  shiftManagerView: ALL,
  isShiftManagerEditValid: true,
  sections: [],
  shiftManager: [],
  shiftManagerEdit: null,
  shiftManagerEditCopy: null,
};

export const shiftManagerManagementSlice = createSlice({
  name: "shiftManagerManagement",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resetShiftManagerManagement.fulfilled, () => initialState)
      .addCase(setShiftManagerView, (state, action) => {
        state.shiftManagerView = action.payload;
      })
      .addCase(fetchDepotSections.pending, (state) => {
        state.loading = true;
        state.sections = [];
      })
      .addCase(fetchDepotSections.fulfilled, (state, action) => {
        const { sections } = action.payload;
        state.loading = false;
        state.sections = sections;
      })
      .addCase(fetchDepotShiftManagers.pending, (state) => {
        state.loading = true;
        state.shiftManagers = [];
      })
      .addCase(fetchDepotShiftManagers.fulfilled, (state, action) => {
        const { shiftManagers } = action.payload;
        state.loading = false;
        state.shiftManagers = shiftManagers;
      })
      .addCase(editShiftManager.pending, (state) => {
        state.loading = true;
        state.shiftManagerEdit = null;
        state.shiftManagerEditCopy = null;
      })
      .addCase(editShiftManager.rejected, (state) => {
        state.loading = false;
        state.shiftManagerEdit = null;
        state.shiftManagerEditCopy = null;
      })
      .addCase(editShiftManager.fulfilled, (state, action) => {
        state.loading = false;
        state.shiftManagerEdit = action.payload;
        state.shiftManagerEditCopy = action.payload;
      })
      .addCase(updateShiftManagerEdit.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateShiftManagerEdit.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateShiftManagerEdit.fulfilled, (state, action) => {
        state.loading = false;
        state.shiftManagerEdit = action.payload;
      })
      .addCase(saveShiftManager.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveShiftManager.rejected, (state) => {
        state.loading = false;
      })
      .addCase(saveShiftManager.fulfilled, (state, action) => {
        state.loading = false;
        state.shiftManagerEdit = null;
        state.shiftManagerEditCopy = null;
        state.shiftManagers = action.payload;
      })
      .addCase(cancelShiftManagerEdit, (state) => {
        state.shiftManagerEdit = null;
        state.shiftManagerEditCopy = null;
      })
      .addCase(setIsShiftManagerEditValid, (state, action) => {
        state.isShiftManagerEditValid = action.payload;
      });
  },
});

const { reducer } = shiftManagerManagementSlice;
export { initialState, reducer };
